type Props = {
  label: string;
  onClick: () => void;
};

// Persistent "back to parent context" affordance shown at the top of detail
// views. Independent of the browser back button — clicking always jumps to
// the role's home (Network Overview for admins, My Portfolio for FBCs),
// regardless of how the user got here.
export default function BackLink({ label, onClick }: Props) {
  return (
    <button type="button" className="back-link" onClick={onClick}>
      <span className="back-link-arrow" aria-hidden="true">
        ←
      </span>
      Back to {label}
    </button>
  );
}
